(() => {
  if (window.collectionPaginationScrollInitialized) return;
  window.collectionPaginationScrollInitialized = true;

  document.addEventListener('click', (event) => {
    const paginationLink = event.target.closest('.collection-page-section .pagination a[data-page]');
    if (!paginationLink) return;

    const section = paginationLink.closest('.collection-page-section');
    const productResults = section?.querySelector('.layer-last');
    const requestedPage = Number(paginationLink.dataset.page);

    if (!productResults || !requestedPage) return;

    let timeoutId;
    const observer = new MutationObserver(() => {
      const currentPage = productResults.querySelector('.pagination [aria-current="page"]');
      if (!currentPage || Number(currentPage.textContent.trim()) !== requestedPage) return;

      observer.disconnect();
      window.clearTimeout(timeoutId);

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const header = document.querySelector('.header-section');
          const headerHeight = header ? header.getBoundingClientRect().height : 0;
          const top = window.scrollY + productResults.getBoundingClientRect().top - headerHeight - 16;

          window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
          });
        });
      });
    });

    observer.observe(productResults, {
      childList: true,
      subtree: true
    });

    timeoutId = window.setTimeout(() => observer.disconnect(), 5000);
  });
})();
